import React, { useState, useEffect, useRef } from "react";
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext';
import SetLoc from '~/utils/set-loc'
import Geoloc from '~/utils/geoloc'
import { imgSize } from '~/utils/helpers'

import IconLoc from '~/components/icons/location'
import Featured from '~/components/stores/featured'
import StoresRegion from '~/components/stores/storesRegion'

import { cta_link } from "~/styles/app.module.scss"
import * as styles from "~/styles/stores/our_stores.module.scss"

const OurStores = ({ data }) => {
  const { locate } = useTheme()
  const { checkZip, deviceLoc } = SetLoc()
  const { getDistances } = Geoloc()
  const inputRef = useRef(null)
  
  const { blocks } = data
  const initial_regions = blocks.find( x => x.type === "regions").settings.regions
  const [regions, setRegions] = useState(initial_regions)
  const [hideFeats, setHideFeats] = useState(false)
  const [inputKey, setInputKey] = useState('zip-input-1')

  const handleZip = async (e) => {
    const types = ['insertText','insertFromPaste']
    if (!types.includes(e.nativeEvent.inputType)) return
      
    const val = e.target.value
    if (val && val.length >= 5) {
      const testzip = await checkZip(val)
      setHideFeats(true)
      return testzip
    }
    if (val === '') setHideFeats(false)
  }

  const handleZipClick = async () => {
    const val = inputRef.current.value
    if (val && val.length >= 5) {
      const testzip = await checkZip(val)
      setHideFeats(true)
      return testzip
    }
    if (val === '') setHideFeats(false)
  }

  const handleDevice = async () => {
    inputRef.current.value = 'Checking location...'
    const device = await deviceLoc()
    return device
  }

  const sortRegions = (regions) => {
    const sorted = getDistances(regions, locate)
    setRegions(sorted)
  }

  useEffect(() => {
    if (!locate) return
    sortRegions(regions)
    setInputKey('zip-input-' + Date.now())

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locate])


  return (
    <div className={styles.stores}>

      <div className={styles.header}>
        <h1 className={styles.title}>
          {data.title}
        </h1>
      </div>

      {blocks.map( (block, index) => {
        const settings = block.settings

        return (
          <React.Fragment key={`topblock_${index}`}>
            {(block.type === "featured_stores") && (
              <div className={`${styles.features} ${hideFeats ? styles.feats_inpt : ''}`}>
                <Featured title={settings.feat_title} stores={settings.stores} />
              </div>
            )}
            
            {(block.type === "regions") && (
              <>
                <div className={styles.header}>
                  <div className={styles.search}>
                    <div className={styles.form}>
                      <input 
                        key={inputKey}
                        id="stores-search_input"
                        className={styles.search_input} 
                        inputMode="numeric" 
                        type="text" 
                        aria-label="Enter Zip Code to Find Closest Store"
                        defaultValue={locate ? locate?.usrZip || locate.zip : undefined}
                        placeholder="Enter zip code to find your store"
                        onInput={(e) => handleZip(e)}
                        ref={inputRef}
                      />
                      <button 
                        type="button"
                        className={styles.loc_btn} 
                        aria-label="Find your location"
                        onClick={(e) => handleDevice()}
                      >
                        <IconLoc />
                      </button>
                      <button 
                        type="button"
                        className={styles.search_btn} 
                        aria-label="Submit search"
                        onClick={(e) => handleZipClick()}
                      />
                    </div>
                  </div>
                </div>

                <div key={`${block.type}${index}`} className={styles.all_stores}>
                  <h2 className={styles.title}>
                    All Stores by Location
                  </h2>
                  <div className={styles.stores_list}>
                    {regions && regions.map( region =>
                      <StoresRegion key={region.region} region={region} />
                    )}
                  </div>
                </div>
              </>
            )}

            {(block.type === "grid") && (
              <div key={`${block.type}${index}`} className={styles.grid}>
                <div className={styles.content}>
                  <div className={styles.subtitle}>
                    {settings.subtitle}
                  </div>
                  <h2 className={styles.title}>
                    {settings.title}
                  </h2>
                  <div className={styles.copy} dangerouslySetInnerHTML={{ __html: settings.copy }} />
                  <div className={styles.cta}>
                    <Flink href={settings.url} className={cta_link}>
                      <span>{settings.link_copy}</span>
                    </Flink>
                  </div>
                </div>
                <Flink 
                  href={settings.url} 
                  className={styles.grid_image}
                  style={{backgroundImage: `url(${imgSize(settings.image,1200)})` }} 
                  aria-label={settings.link_copy}
                ></Flink>
              </div>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default OurStores



